// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qr-modal_wrapper__13zKr","card":"qr-modal_card__3DZ0g","header":"qr-modal_header__37aLY","body":"qr-modal_body__3O1OA","footer":"qr-modal_footer__21tvK"};